import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcExternalLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path fill="currentColor" d="M4 4h12v2H6v20.08h20v-9.6h2V28H4V4Z" />
      <path stroke="currentColor" d="M27.5 4.5v7h-1v-6h-6v-1h7Z" />
      <path
        fill="currentColor"
        d="M15.26 14.67 25.5 5.124l1.363 1.462-10.239 9.548z"
      />
    </g>
  </svg>
);
export default SvgIcExternalLink;
